import { render, staticRenderFns } from "./promotions-list.view.vue?vue&type=template&id=1fa96450&scoped=true"
import script from "./promotions-list.view.vue?vue&type=script&lang=ts"
export * from "./promotions-list.view.vue?vue&type=script&lang=ts"
import style0 from "./promotions-list.view.vue?vue&type=style&index=0&id=1fa96450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa96450",
  null
  
)

export default component.exports